export enum FeatureUpgrade {
  SPACES = 'spaces',
  TEAM = 'team',
  SLACK = 'slack',
  SALESFORCE = 'salesforce',
  HUBSPOT = 'hubspot',
  SIGNATURE = 'signature',
  DEVELOPER = 'developer'
}
